import * as React from 'react';

const CrossSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="cross_svg__eds-icon--cross_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="cross_svg__eds-icon--cross_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M18.3 5L12 11.3 5.7 5l-.7.7 6.3 6.3L5 18.3l.7.7 6.3-6.3 6.3 6.3.7-.7-6.3-6.3L19 5.7z"
        />
    </svg>
);

CrossSvg.displayName = 'CrossSvg';
export default CrossSvg;
